
import { mapGetters } from 'vuex'
import Currency from '~/mixins/Currency.js'
import ProductNumber from '~/mixins/ProductNumber.js'

export default {
  mixins: [Currency, ProductNumber],

  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },

    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('favorites', ['favorites']),

    productPrice() {
      return this.$auth.$state.priceInclTax
        ? this.product.gross_price
        : this.product.price
    },

    isFavorite() {
      return this.favorites?.items?.some(
        (favorite) => favorite.entry_id === this.product.id
      )
    },
  },

  methods: {
    async toggleFavorite(isFavorite) {
      if (isFavorite) {
        await this.$store.dispatch(
          'favorites/removeFromFavorites',
          this.product.id
        )
      } else {
        await this.$store.dispatch('favorites/addToFavorites', this.product.id)
        this.$store.commit('favorites/setOpen')
      }
    },
  },
}
